"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _uiKit = require("@devsta/ui-kit");

var _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function BrandSummary(_ref) {
  var subBrandId = _ref.subBrandId,
      coverImageKey = _ref.coverImageKey,
      name = _ref.name,
      updatedAt = _ref.updatedAt,
      gotoBrand = _ref.gotoBrand;
  return _react.default.createElement("div", {
    onClick: gotoBrand(subBrandId),
    onKeyPress: (0, _onEnterPressed.default)({
      onClick: gotoBrand(subBrandId)
    }),
    className: "brands-list__images__summary",
    role: "button",
    tabIndex: 0
  }, coverImageKey ? _react.default.createElement(_uiKit.Image, {
    width: "100%",
    height: "100%",
    imageUrl: coverImageKey
  }) : _react.default.createElement("div", {
    className: "without-image"
  }), _react.default.createElement("div", {
    className: "brands-list__images__summary__text"
  }, _react.default.createElement("p", null, name), _react.default.createElement("p", null, "Updated ".concat((0, _moment.default)(updatedAt, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format('DD MMM YYYY')))));
}

var _default = (0, _react.memo)(BrandSummary);

exports.default = _default;